import React, { useContext, useEffect, useMemo } from 'react';
import { Forms, Form, useFormsContext } from '@ally/forms';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DATE_PICKER_FORMAT, SERVER_TIMEZONE } from '../constants';
import { TransferAccountsContext, TransferSpeedsContext, TransferSpeedsProvider, useComputedValues, useDeliveryDatePrePop, HolidaysProvider, useTransferSpeeds, } from '../hooks';
import { RemoteStatus } from '../Remote';
import { formValuesToTransfer, getMinDeliveryDate } from '../utils';
dayjs.extend(utc);
dayjs.extend(timezone);
var TransferForm = function (_a) {
    var hostServices = _a.hostServices, children = _a.children;
    var _b = useFormsContext(), formId = _b.formId, setFieldValue = _b.setFieldValue;
    var transferSpeeds = useTransferSpeeds(hostServices).transferSpeeds;
    var _c = useComputedValues(), transferType = _c.transferType, frequency = _c.frequency;
    var minDeliveryDate = useMemo(function () {
        return getMinDeliveryDate({
            frequency: frequency,
            transferSpeeds: transferSpeeds,
            transferType: transferType,
        });
    }, [frequency, transferSpeeds, transferType]);
    /**
     * The delivery date pre-pop is handled here instead of in the delivery date
     * input because there is a scenario where we need to skip the first render of
     * the entire form.
     */
    var prePopDate = useDeliveryDatePrePop({ minDeliveryDate: minDeliveryDate });
    useEffect(function () {
        if (prePopDate) {
            setFieldValue('deliveryDate', prePopDate.format(DATE_PICKER_FORMAT), true);
        }
    }, [prePopDate, setFieldValue]);
    return React.createElement(Form, { id: formId }, children);
};
var InternalFormWrapper = function (_a) {
    var children = _a.children, initialValues = _a.initialValues, onSubmit = _a.onSubmit, hostServices = _a.hostServices, accounts = _a.accounts;
    var _b = useContext(TransferSpeedsContext), selectedSpeed = _b.selectedSpeed, withdrawalDateRemote = _b.withdrawalDate;
    var handleSubmit = function (values, formikHelpers) {
        formikHelpers.setSubmitting(false);
        var withdrawalDate = withdrawalDateRemote.status === RemoteStatus.Loaded
            ? withdrawalDateRemote.data
            : dayjs.tz(values.deliveryDate, DATE_PICKER_FORMAT, SERVER_TIMEZONE);
        var meta = {
            transferSpeed: selectedSpeed,
            withdrawalDate: withdrawalDate,
        };
        var transfer = formValuesToTransfer(values, accounts, meta);
        onSubmit({ values: values, meta: meta, transfer: transfer });
    };
    return (React.createElement(Forms, { formId: "transfer-form", initialValues: initialValues, onSubmit: handleSubmit, validateOnChange: false },
        React.createElement(TransferForm, { hostServices: hostServices }, children)));
};
var TransferFormWrapper = function (_a) {
    var children = _a.children, initialValues = _a.initialValues, onSubmit = _a.onSubmit, accounts = _a.accounts, hostServices = _a.hostServices;
    return (React.createElement(TransferSpeedsProvider, null,
        React.createElement(TransferAccountsContext.Provider, { value: accounts },
            React.createElement(HolidaysProvider, { hostServices: hostServices },
                React.createElement(InternalFormWrapper, { hostServices: hostServices, initialValues: initialValues, onSubmit: onSubmit, accounts: accounts }, children)))));
};
export default TransferFormWrapper;
//# sourceMappingURL=TransferFormWrapper.js.map